import { useMemo } from "react"

import { useAvailableTokens, useDepositedTokens } from "#/shared/hooks"

import TokensIcons from "./TokensIcons"

type AvailableTokensProps = {
  tokensToDisplay: "deposit-tokens" | "available-tokens"
}

export default function AvailableTokens({
  tokensToDisplay,
}: AvailableTokensProps) {
  const { availableTokens } = useAvailableTokens()
  const { depositTokens } = useDepositedTokens()

  // Based on the prop we determine whether we should display
  // tokens from active deposits or tokens that are available
  // in the connected wallet
  const tokens = useMemo(
    () =>
      tokensToDisplay === "deposit-tokens" ? depositTokens : availableTokens,
    [tokensToDisplay, depositTokens, availableTokens],
  )

  return <TokensIcons tokens={tokens} />
}
